import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faMapMarkerAlt, faEdit, faStreetView, faRoute } from '@fortawesome/free-solid-svg-icons';
import { Row, Col, Button } from 'reactstrap';
import moment from 'moment';
import { MapContainer, TileLayer, Marker, Tooltip, Polyline } from 'react-leaflet';
import { iconeNormal } from '../../../../assets/Icons/Icons';
//components
import TabelaListaGeradores from './TabelaListaGeradores';
//Helpers
import { conectarPontos } from '../../../../helpers/mapas';

export default function ContainerFichaOrdemColeta({ editar, ordemColeta }) {
    const [map, setMap] = useState(null);
    const [location, setLocation] = useState([-23.2198396, -45.8915658]);
    const [viewSatelite, setViewSatelite] = useState(() => false);
    const toggleViewSatelite = () => setViewSatelite(() => !viewSatelite);
    const [pointSelected, setPointSelected] = useState(null);
    const [linhas, setLinhas] = useState([]);

    useEffect(() => {
        if (ordemColeta.items) {
            setLinhas(conectarPontos(ordemColeta.items.filter(value => !value.excluido)));
        }
    }, []);
    const greenOptions = { color: 'green' }
    return (
        <div className='mb-3' style={{ color: "#666" }}>
            <div className="d-flex align-items-center justify-content-between">
                <p><span className="fw-bold">Data:</span> {moment(ordemColeta.dataColeta).format("DD/MM/YYYY")}</p>
                <p><span className="fw-bold">Status:</span>{ordemColeta && ordemColeta.idOrdem === 0 ? ordemColeta.statusOrdem : ordemColeta.status}</p>
            </div>
            <h5 className="bg-gradient bg-primary p-2 rounded-3 text-light d-flex align-items-center justify-content-between"><span><FontAwesomeIcon className='me-2' icon={faPencilAlt} /> Identificação da rota</span> {editar ? <button className='btnEditFicha' onClick={() => editar(1)}><FontAwesomeIcon icon={faEdit} /></button> : <></>}</h5>
            <Row>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Descrição: </span> {ordemColeta && ordemColeta.descricao}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Veiculo: </span> {ordemColeta && ordemColeta.tbVeiculos_Placa}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Destino: </span> {ordemColeta && ordemColeta.tbDestinos_Fantasia}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Motorista: </span> {ordemColeta.motorista}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Status: </span> {ordemColeta.statusRota}</p>
                </Col>
            </Row>
            <h5 className="bg-gradient bg-primary p-2 rounded-3 text-light d-flex align-items-center justify-content-between"><span><FontAwesomeIcon className='me-3' icon={faMapMarkerAlt} /> Lista de geradores</span> {editar ? <button className='btnEditFicha' onClick={() => editar(2)}><FontAwesomeIcon icon={faEdit} /></button> : <></>}</h5>
            <TabelaListaGeradores ordemColeta={ordemColeta} items={ordemColeta.items} ficha={true} />
            <h5 className="bg-gradient bg-primary p-2 rounded-3 text-light d-flex align-items-center justify-content-between"><span><FontAwesomeIcon className='me-3' icon={faRoute} />Rota de coleta</span> {editar ? <button className='btnEditFicha' onClick={() => editar(2)}><FontAwesomeIcon icon={faEdit} /></button> : <></>}</h5>

            <Row style={{ height: "50vh", backgroundColor: "#eee" }} className="mt-3 rounded-3 overflow-hidden shadow">
                <Col md="12" lg="12" className=' m-0 p-0'>
                    <MapContainer
                        center={ordemColeta.items.filter(value => !value.excluido) && ordemColeta.items.filter(value => !value.excluido).length > 0 ? [ordemColeta.items.filter(value => !value.excluido)[0].latitude, ordemColeta.items.filter(value => !value.excluido)[0].longitude] : location}
                        zoom={13}
                        ref={setMap}
                        style={{ height: "100%", width: "100%", backgroundColor: "#333" }}
                    >
                        <Button color='light border' className='buttonSatelite' onClick={toggleViewSatelite}><FontAwesomeIcon size='1x' icon={faStreetView} /></Button>
                        <TileLayer
                            url="https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"
                            attribution='© <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, © <a href="https://carto.com/attribution">CARTO</a>'
                        />
                        {
                            viewSatelite
                            &&
                            <TileLayer
                                url='https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}'
                                maxZoom={20}
                                subdomains={['mt1', 'mt2', 'mt3']}
                            />

                        }



                        {ordemColeta && ordemColeta.items && ordemColeta.items.filter(value => !value.excluido).map((value, index) => {
                            if (value.latitude && value.longitude) {
                                return (
                                    <Marker key={index} icon={iconeNormal} position={[parseFloat(value.latitude), parseFloat(value.longitude)]}
                                        eventHandlers={{
                                            click: (e) => {
                                                setLocation(e.latlng);
                                                map.flyTo(e.latlng);
                                                setPointSelected(value);
                                            },
                                        }}
                                    >
                                        <Tooltip direction='center' className='leaflet-tooltip-green' offset={[0, 0]} opacity={1} permanent>
                                            <span>{value.sequencia}</span>
                                        </Tooltip>
                                    </Marker>
                                )
                            }
                        })}
                        {
                            linhas.map(value => {
                                return <Polyline pathOptions={greenOptions} positions={value} />
                            })
                        }
                    </MapContainer>

                </Col>
            </Row>
        </div>);
}